import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'pinned', 'Pinned', [["path",{"d":"M9 4v6l-2 4v2h10v-2l-2 -4v-6"}],["path",{"d":"M12 16l0 5"}],["path",{"d":"M8 4l8 0"}]]);